'use client';

import { NavigationMenu } from '@wwe-portal/ui/components/navigation';
import { WEBCOIN_SECTIONS } from '@wwe-portal/web/utils/constants/webcoin';
import { useScrollOffset } from '@wwe-portal/web/providers/stores/layout-store';
import { useEffect, useMemo } from 'react';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';
import { useNavigationWithSearchParam } from '@wwe-portal/web/hooks/common/use-navigation-with-search-param';
import debounce from 'lodash.debounce';
import { ANALYTICS_VIEWED_LIMIT_MS } from '../../utils/config';
import { sendSectionViewedEvent } from '../../libs/analytics/web-coin-shop';

const menuItems = [
  {
    id: WEBCOIN_SECTIONS.PLAYER_AVATARS,
    label: 'Player Avatars',
    icon: (
      <IcoMoonIcon iconName="account-box-fill" className="h-[18px] w-[18px]" />
    ),
  },
  {
    id: WEBCOIN_SECTIONS.AVATAR_FRAMES,
    label: 'Avatar Frames',
    icon: <IcoMoonIcon iconName="frames" className="h-[18px] w-[18px]" />,
  },
  {
    id: WEBCOIN_SECTIONS.DAILY_WEBCOIN_OFFERS,
    label: 'Web Coin Offers',
    icon: (
      <IcoMoonIcon iconName="web-coin-circle" className="h-[18px] w-[18px]" />
    ),
  },
  {
    id: WEBCOIN_SECTIONS.ENERGY_PACKS,
    label: 'Energy Packs',
    icon: (
      <IcoMoonIcon iconName="battery-charging" className="h-[18px] w-[18px]" />
    ),
  },
];

export const WebCoinNavigation = () => {
  const scrollOffset = useScrollOffset();
  const { isMobile } = useResponsive();

  const { activeId, handleItemClick, lockedActiveId } =
    useNavigationWithSearchParam(menuItems, 'category');

  const actualActiveId = lockedActiveId ?? activeId;

  const getSectionActive = useMemo(
    () =>
      debounce((actualActiveId) => {
        sendSectionViewedEvent(actualActiveId);
      }, ANALYTICS_VIEWED_LIMIT_MS),
    []
  );

  useEffect(() => {
    if (actualActiveId) getSectionActive(actualActiveId);
  }, [actualActiveId, getSectionActive]);

  return (
    <div
      className="z-sticky data-[sticky=true]:bg-back600 sticky top-[60px] mx-[-20px] px-5 py-5 xl:top-[70px] xl:mx-[-30px] xl:px-[30px]"
      data-sticky={scrollOffset && scrollOffset > 55}
    >
      <NavigationMenu
        activeId={actualActiveId}
        items={
          isMobile
            ? menuItems.map((item) => ({ ...item, icon: undefined }))
            : menuItems
        }
        onClick={handleItemClick}
        className="grid grid-flow-col justify-stretch"
      />
    </div>
  );
};
